import { useContext } from 'react';
import StudioContext from '@contexts/StudioContext';

export const useStudioContext = () => useContext(StudioContext);
